import fetch from './fetch'

class TaskApi {
	public addTask(form: any) {
		return fetch({
			url: 'injury/order/add',
			method: 'post',
			data: form,
		})
	}

	public addActivity(form: any) {
		return fetch({
			url: 'injury/order/addActivity',
			method: 'post',
			data: form,
		})
	}

	public addHomeSurvey(form: any) {
		return fetch({
			url: 'injury/order/addHomeSurvey',
			method: 'post',
			data: form,
		})
	}

	public addOtherInvestigate(form: any) {
		return fetch({
			url: 'injury/order/addOtherSurvey',
			method: 'post',
			data: form,
		})
	}

	public getTaskList(form: any) {
		return fetch({
			url: 'injury/tasklist/query',
			method: 'post',
			data: form,
		})
	}

	public getCommonTaskList(form: any) {
		return fetch({
			url: 'injury/tasklist/injuryList',
			method: 'post',
			data: form,
		})
	}

	public omitRisk(riskId: string) {
		return fetch({
			url: 'injury/order/ignoreRisk',
			method: 'GET',
			params: {
				riskDetailId: riskId,
			},
		})
	}

	public cancelRiskDeal(riskId: string) {
		return fetch({
			url: 'injury/order/cancelRiskDeal',
			method: 'GET',
			params: {
				riskDetailId: riskId,
			},
		})
	}

	public getTaskDetail(orderId: string, desensitize: boolean = false, key: string = '') {
		return fetch({
			url: 'injury/order/detail',
			params: {
				orderId,
				desensitize, // 是否脱敏
				key,
			},
		})
	}

	public getOpenDetail(orderId: string, key: string = '') {
		return fetch({
			url: 'injury/order/open/detail',
			params: {
				orderId,
				key,
			},
		})
	}

	public getTaskDetailForSnapshot(orderId: string) {
		return fetch({
			url: 'injury/order/snapshot/detail',
			params: {
				orderId,
			},
		})
	}

	public getTaskLog(orderId: string) {
		return fetch({
			url: 'injury/tasklog/get',
			params: {
				orderId,
			},
		})
	}

	public setTaskManual(data: any) {
		return fetch({
			url: 'injury/manual/save',
			method: 'post',
			data: data,
		})
	}

	public getH5TaskManual(form: any) {
		return fetch({
			url: 'injury/manual/queryOrderConfig',
			params: {
				...form,
			},
		})
	}

	public getTaskManual() {
		return fetch({
			url: 'injury/manual/query',
		})
	}

	public isManualConfigurable(insuranceType: string) {
		return fetch({
			url: 'injury/manual/isNeedConfig',
			params: {
				insuranceType,
			},
		})
	}

	public isSendManual(insuranceType: string) {
		return fetch({
			url: 'injury/manual/isNeedSendManual',
			params: {
				insuranceType,
			},
		})
	}

	public exportSurveyOrderAudio(orderId: string) {
		return fetch({
			url: 'injury/order/exportSurveyOrderAudio',
			method: 'post',
			params: {
				orderId,
			},
			responseType: 'blob',
		})
	}

	public exportList(form: any) {
		return fetch({
			url: 'injury/tasklist/export',
			method: 'post',
			data: form,
			timeout: 0,
			responseType: 'blob',
		})
	}

	public getExportFileId(form: any) {
		return fetch({
			url: 'injury/tasklist/injuryListExport',
			method: 'post',
			data: form,
			timeout: 0,
		})
	}

	public exportDownload(fileId: string) {
		return fetch({
			url: 'injury/tasklist/download',
			method: 'GET',
			params: {
				fileId,
			},
			responseType: 'blob',
		})
	}

	public batchExport(orderIds: any[]) {
		return fetch({
			url: 'injury/order/batchExport',
			method: 'post',
			data: {
				orderIds,
			},
			timeout: 0,
			responseType: 'blob',
		})
	}

	public exportOrder(params: any) {
		return fetch({
			url: 'injury/order/export',
			method: 'post',
			params,
		})
	}

	public cancelOrder(form: any) {
		return fetch({
			url: 'injury/order/cancel',
			method: 'post',
			data: form,
		})
	}

	public resendOrder(orderId: string) {
		return fetch({
			url: 'injury/order/resend',
			params: {
				orderId,
			},
		})
	}

	public checkTask(form: any) {
		return fetch({
			url: 'injury/task/checkTaskInfo',
			method: 'post',
			data: form,
		})
	}

	public checkCancelInfo(form: any) {
		return fetch({
			url: 'injury/task/checkCancelInfo',
			method: 'post',
			data: form,
		})
	}

	public auditTask(form: any) {
		return fetch({
			url: 'injury/task/auditTask',
			method: 'post',
			data: form,
		})
	}

	public searchCompany(companyName: string) {
		return fetch({
			url: 'injury/resource/searchByName',
			method: 'GET',
			params: {
				companyName,
			},
		})
	}

	public getMsgToken(orderNo: string) {
		return fetch({
			url: 'injury/resource/token',
			params: {
				orderNo,
				userType: '0',
			},
		})
	}

	public expireToken(orderNo: string) {
		return fetch({
			url: 'injury/resource/expireToken',
			params: {
				orderNo,
				userType: '0',
			},
		})
	}

	public getOrderStatus(orderId: string) {
		return fetch({
			url: 'injury/order/status',
			params: {
				orderId,
			},
		})
	}

	public auditCancelTask(form: any) {
		return fetch({
			url: 'injury/task/auditCancelTask',
			method: 'post',
			data: form,
		})
	}

	public postponeOrder(form: any) {
		return fetch({
			url: 'injury/order/postpone',
			params: form,
		})
	}

	public getOrderExStatusInfo(orderId: any) {
		return fetch({
			url: 'injury/order/getOrderExStatusInfo',
			params: {
				orderId,
			},
		})
	}

	public getRelationOrders(form: any) {
		return fetch({
			url: '/injury/order/relationOrders',
			method: 'post',
			data: form,
		})
	}

	public getVisitorAreaDistribution(keyword: string) {
		return fetch({
			url: '/injury/visitor/visitorAreaDistribution',
			method: 'GET',
			params: keyword,
		})
	}

	public getExceptionList(form: any) {
		return fetch({
			url: '/injury/tasklist/exceptionList',
			method: 'POST',
			data: form,
		})
	}

	public exportException(form: any) {
		return fetch({
			url: '/injury/tasklist/exception/export',
			method: 'post',
			data: form,
			responseType: 'blob',
		})
	}

	public changePartner(form: any) {
		return fetch({
			url: '/injury/task/dispatch/changePartner',
			method: 'post',
			params: form,
		})
	}

	public exportOtherSurvey(params: any) {
		return fetch({
			url: '/injury/order/exportOtherSurvey',
			method: 'post',
			params,
		})
	}

	public hasWholeProcessRight() {
		return fetch({
			url: '/injury/wholeprocess/checkRight',
			method: 'get',
		})
	}

	public getFirstTaskInfo(form: any) {
		return fetch({
			url: 'injury/wholeprocess/getFirstTaskInfo',
			method: 'get',
			params: form,
		})
	}

	public getDetailPendingList(form: any) {
		return fetch({
			url: '/injury/revisit/trackTaskList',
			method: 'POST',
			data: form,
		})
	}

	public getMsgBoardList(form: any) {
		return fetch({
			url: '/injury/message/board/list',
			method: 'post',
			data: form,
		})
	}

	public addMsgBoard(form: any) {
		return fetch({
			url: '/injury/message/board/add',
			method: 'post',
			data: form,
		})
	}

	public checkExportFinish(params: any) {
		return fetch({
			url: '/injury/order/getPackageInfo',
			method: 'get',
			params,
		})
	}

	public downloadWithKey(params: any) {
		return fetch({
			url: '/injury/order/downloadPackage',
			method: 'get',
			params,
			timeout: 0,
			responseType: 'blob',
		})
	}

	// 获取报案号列表
	public getCaseNoList(params: any) {
		return fetch({
			url: '/injury/order/getOrderBaseInfo',
			method: 'get',
			params,
		})
	}

	// 删除留言板图片
	public delBoard(messageId: any) {
		return fetch({
			url: '/injury/message/board/del',
			method: 'post',
			params: {
				messageId,
			},
		})
	}
	// 资料已补
	public sufficiency(params: any) {
		return fetch({
			url: '/injury/order/sufficiency',
			method: 'post',
			params,
		})
	}
	// 回传保司
	public post2Insurance(params: any) {
		return fetch({
			url: '/injury/order/post2Insurance',
			method: 'get',
			params,
		})
	}
	// 深度整案调查作业
	public operation(params: any) {
		return fetch({
			url: '/injury/task/pc/operation',
			method: 'post',
			params,
		})
	}
	// 其他调查暂存
	public autoSave(form: any) {
		return fetch({
			url: '/injury/task/autoSave',
			method: 'post',
			data: form,
		})
	}
	// 获取打水印信息
	public orderBaseInfo(params: any) {
		return fetch({
			url: '/injury/message/board/orderBaseInfo',
			method: 'post',
			params,
		})
	}
	public getFileUrl(fileId: any) {
		return fetch({
			url: '/injury/resource/getFileUrl',
			method: 'post',
			params: {
				fileId,
			},
		})
	}
	// 获取阿里云oss信息
	public getAliyunOssInfo() {
		return fetch({
			url: '/injury/resource/getAliyunOssInfo',
			method: 'post',
		})
	}
	// 提交作业
	public Save(form: any) {
		return fetch({
			url: '/injury/task/save',
			method: 'post',
			data: form,
		})
	}
}

export default new TaskApi()
